<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.affiliations', 2) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card-title">
                    <router-link :to="{ name: 'add-affiliation' }" v-if="can">
                        {{ $t('message.add') }}

                        <i class="fas fa-plus-circle edit-icon"></i>
                    </router-link>
                </div>

                <template v-if="rows">
                    <b-container>
                        <b-row class="justify-content-sm-center">
                            <b-col col sm="6">
                                <b-form-group>
                                    <autocomplete
                                            ref="autocomplete"
                                            :placeholder="$t('message.search')"
                                            :source="mAffiliations"
                                            input-class="form-control"
                                            results-property="data"
                                            :results-display="formattedDisplay"
                                            @selected="itemSelected"
                                    ></autocomplete>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-container>

                    <b-table
                            id="affiliations-table"
                            primary-key="id"
                            :per-page="perPage"
                            :current-page="currentPage"
                            selectable
                            select-mode="single"
                            borderless
                            responsive
                            striped
                            hover
                            @row-selected="rowSelected"
                            :fields="fields"
                            :items="mAffiliations"
                    >
                        <!-- A virtual composite column for actions -->
                        <template slot="action" slot-scope="data" v-if="can">
                            <div class="row">
                                <div class="col-sm-6">
                                    <b-link :to="{ name: 'edit-affiliation', params: { affiliation: data.item.slug } }">
                                        <i class="fas fa-edit fa-2x edit-icon"></i>
                                    </b-link>
                                </div>

                                <div class="col-sm-6">
                                    <i v-b-modal="'delete-modal-' + data.item.slug" class="fas fa-trash fa-2x delete-icon"></i>
                                </div>
                            </div>

                            <b-modal
                                    :id="'delete-modal-' + data.item.slug"
                                    size="sm"
                                    header-bg-variant="danger"
                                    header-text-variant="light"
                                    :title="$t('message.delete') + ' ' + $tc('message.affiliations', 1)"
                                    hide-footer
                            >
                                <div class="d-block text-center">
                                    <h3>{{ $t('message.delete') }} {{ data.item.title }}?</h3>
                                </div>

                                <div class="d-block float-right">
                                    <b-button class="secondary" @click="deleteAffiliation(data.item.slug)">
                                        {{ $t('message.delete') }}
                                    </b-button>

                                    <b-button class="danger" @click="$bvModal.hide('delete-modal-' + data.item.slug)">
                                        {{ $t('message.cancel') }}
                                    </b-button>
                                </div>
                            </b-modal>
                        </template>
                    </b-table>

                    <b-pagination
                            class="justify-content-center"
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                            aria-controls="affiliations-table"
                    ></b-pagination>
                </template>

                <template v-else>
                    <div class="card">
                        <div class="card-body text-xs-center">
                            <p class="card-text">
                                {{ $t('message.noResults') }}
                            </p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import _ from 'lodash';

    export default {
        name: "Affiliations",

        computed: {
            ...mapGetters(["affiliations",'hasAdminRole',
                'hasGestionnaireRole']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole;
            },
            mAffiliations: function() {
                let aArray = [];

                _.forEach(_.orderBy(this.affiliations,['created_at'],['desc']), function(affiliation) {
                    let a = {};
                    if (typeof affiliation.user == "object"){
                        if (typeof affiliation.souscripteur == "object"){

                            let user = affiliation.user;
                            let prenom = user.prenom != null ? user.prenom : "";
                            a.nom  = (user.nom).toUpperCase()+" " + prenom.charAt(0).toUpperCase() + prenom.substring(1);
                            let subscriber = affiliation.souscripteur;
                            let subPrenom = subscriber.prenom != null ? subscriber.prenom : "";
                            a.subscribers  = (subscriber.nom).toUpperCase()  + " "+subPrenom.charAt(0).toUpperCase() + subPrenom.substring(1);
                            a.type = affiliation.nom;
                            a.date_debut = moment(affiliation.date_debut).format('DD-MM-YYYY');
                            a.date_fin = moment(affiliation.date_fin).format('DD-MM-YYYY');
                            a.date = moment(affiliation.created_at).format('DD-MM-YYYY HH:mm');
                            a.id = affiliation.id;
                            a.slug = affiliation.slug;

                            aArray.push(a);
                        }
                    }
                });

                return aArray;
            },

            rows: function() {
                return this.mAffiliations.length;
            }
        },

        data() {
            return {
                perPage: 10,
                currentPage: 1,
                // sortBy: 'date',
                // sortDesc: true,
                fields: [
                    {
                        key: 'nom',
                        label: this.$i18n.t('message.name'),
                    },
                    {
                        key: 'type',
                        label: this.$i18n.tc('message.types',2),
                    },
                    {
                        key: 'subscribers',
                        label: this.$i18n.tc('message.subscribers',1),
                    },
                    {
                        key: 'date_debut',
                        label: this.$i18n.t('message.startDate'),
                    },
                    {
                        key: 'date_fin',
                        label: this.$i18n.t('message.endDate'),
                    },
                    {
                        key: 'action',
                        label: this.$i18n.tc('message.operations', 1)
                    }
                ],
                offset: 0,
                limit: -1,
            }
        },

        methods: {
            getUserAffiliations() {
                let args = {
                    offset: this.offset,
                    limit: this.limit
                };

                this.$store.dispatch('getAffiliations', { args : args });
            },

            formattedDisplay (result) {
                return result.nom;
            },

            itemSelected(item) {
                this.$router.push({ name: 'affiliation', params: { affiliation: item.selectedObject.slug } });
            },

            rowSelected(items) {
                this.$router.push({ name: 'affiliation', params: { affiliation: items[0].slug } });
            },

            deleteAffiliation(affiliation) {
                let self = this;

                let args = {
                    affiliation: affiliation
                };

                let successMessage = this.$i18n.t('message.affiliationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAffiliation', { args, index: affiliation, successMessage, errorMessages })
                    .then(() => {
                        self.$bvModal.hide('delete-modal-' + affiliation);
                    });
            }
        },

        mounted() {
            // Fetch affiliations list
            this.getUserAffiliations();
        }
    }
</script>

<style scoped>

</style>